import React, { Fragment } from "react";

const CompanyOnlineUsers = () => {
  return (
    <Fragment>
      <div className="online-users-profile">
        <div className="online-title-container-alt">
          <div className="border-alt blue">
            <p className="online-title-alt blue">Comcast</p>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user blue">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border blue">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="blue name-font">Employer Name</span>
                </li>
                <li className="user-online-item">Recruiter Name</li>
                <li className="user-online-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CompanyOnlineUsers;
